import React, { createContext, ReactNode, useContext, useMemo, useState } from 'react';
import { LoginRecoveryOptionsType } from '../hooks/utility';

export type LoginRecoveryOptionsContextProps = {
  loginRecoveryOptions: LoginRecoveryOptionsType;
  setLoginRecoveryOptions: (_: LoginRecoveryOptionsType | undefined) => void;
};

export const LoginRecoveryOptionsContext = createContext<LoginRecoveryOptionsContextProps | null>(
  null
);

export const LoginRecoveryOptionsContextProvider = ({ children }: { children: ReactNode }) => {
  const [loginRecoveryOptions, setLoginRecoveryOptions] = useState<
    LoginRecoveryOptionsType | undefined
  >();

  const value = useMemo(
    (): LoginRecoveryOptionsContextProps => ({
      loginRecoveryOptions,
      setLoginRecoveryOptions,
    }),
    [loginRecoveryOptions]
  );

  return (
    <LoginRecoveryOptionsContext.Provider value={value}>
      {children}
    </LoginRecoveryOptionsContext.Provider>
  );
};

export const useLoginRecoveryOptionsContext = () => {
  const context = useContext(LoginRecoveryOptionsContext);

  if (!context) {
    throw new Error(
      'useLoginRecoveryOptionsContext must be used within a LoginRecoveryOptionsContextProvider'
    );
  }

  return context;
};
